// @module TavanoTeam.CapSciExtensions.CSSearchSpringExt
define('TavanoTeam.CapSciExtensions.CSSearchSpringExt.PDP'
,	[
		'ProductDetails.Full.View'
	,	'Profile.Model'

	,	'SC.Configuration'

	,	'underscore'
	,	'jQuery'
	]
,   function (
		ProductDetailsFullView
	,	ProfileModel

	,	Configuration

	,	_
	,	jQuery
	)
{
	'use strict';

	return  {
		loadSearchSpringPDP: function loadSearchSpringPDP (container)
		{
			// var layout = container.getComponent('Layout');

			// console.log("layout", layout);
			
			// layout.application.getLayout().on('beforeAppendView', function()
			// {
			// 	console.log("here");
			// 	var script = jQuery('<script type="text/javascript" src="//cdn.searchspring.net/intellisuggest/is.min.js"></script>');
					
			// 	jQuery('body').append(script);
			// });

            _.extend(ProductDetailsFullView.prototype, {
                initialize: _.wrap(ProductDetailsFullView.prototype.initialize, function(fn, options)
                {
                    var origInit = fn.apply(this,_.toArray(arguments).slice(1));

                    options.application.getLayout().on('afterAppendView', this.loadIntelliSuggestPDP, this);

                    return origInit;
				})
            ,   loadIntelliSuggestPDP: function()
                {
                    var item = this.model.get('item')
					,   sku = item.get('_sku');
					
					try {
						IntelliSuggest.init({siteId:'ejxf37', context:'Product/' + sku, seed:[sku]});

						IntelliSuggest.viewItem({sku:sku});
					}
					catch(err) {
						//console.log("err", err);
						return err;
					}
                }
            });
		}
	};
});
